module.exports = __webpack_public_path__ + "img/W-S70.84314135.jpg";